import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Customers';
import Object from './components/Customer';

import LocationCollection from './components/Locations';
import LocationObject from './components/Location';

import CustomersLogs from "./components/CustomersLogs";

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions,roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/logs`}>
				<CustomersLogs regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id/locations/:location`}>
				<LocationObject regions={regions} baseUrl={`${match.url}/${match.params.id}/locations`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id/locations`}>
				<LocationCollection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} baseUrl={match.url} roles={roles}/>
			</ErrorBoundaryRoute>

			{roles.length === 1 && roles[0] === 40 ?
				<ErrorBoundaryRoute>
					<Redirect to={`/engineers`} />
				</ErrorBoundaryRoute>
				:
				<ErrorBoundaryRoute>
					<Redirect to={`${match.url}`} />
				</ErrorBoundaryRoute>}
		</Switch>
	</div>
);
